'use client';

import React, { useState, useEffect, useCallback } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import {
  X,
  ChevronLeft,
  ChevronRight,
  ZoomIn,
  Car,
  UserRound,
  ShieldCheck,
  Clock3,
  ArrowRight,
  CheckCircle2,
  MapPin,
  Camera,
} from 'lucide-react';

interface GalleryItem {
  id: number;
  src: string;
  title: string;
  description: string;
  alt: string;
  category: string;
  location: string;
}

const galleryItems: GalleryItem[] = [
  {
    id: 1,
    src: '/assets/images/Armada Nayvera.jpeg',
    title: 'Armada Masuk Garasi',
    description:
      'Setiap armada kembali ke garasi untuk diperiksa, dibersihkan, dan dipastikan siap digunakan kembali untuk perjalanan berikutnya.',
    alt: 'Armada NAYVERA INDO TRANSPORT',
    category: 'Armada',
    location: 'Jabodetabek',
  },
  {
    id: 2,
    src: '/assets/images/Armada Alphard HEV NAYVERA.jpeg',
    title: 'Armada Stanby 	',
    description:
      'Mendukung kebutuhan perjalanan bisnis dengan layanan transportasi yang profesional dan tepat waktu.',
    alt: 'Armada NAYVERA INDO TRANSPORT',
    category: 'Armada',
    location: 'Garasi Nayvera Indo Transport',
  },
  {
    id: 3,
    src: '/assets/images/Driver WilDan.jpeg',
    title: 'Driver WilDan',
    description:
      'Driver berpengalaman yang siap memberikan pelayanan ramah, sopan, dan profesional.',
    alt: 'Driver profesional NAYVERA',
    category: 'Driver',
    location: 'NAYVERA INDO TRANSPORT',
  },
  {
    id: 4,
    src: '/assets/images/Gambar Utama Galery.jpeg',
    title: 'Momen Perjalanan',
    description:
      'Menemani perjalanan wisata bersama keluarga, komunitas, maupun rombongan.',
    alt: 'Perjalanan Rombongan bersama NAYVERA',
    category: 'Perjalanan',
    location: 'Kabupaten Bogor︱2026 60.02 10:27',
  },
  {
    id: 5,
    src: '/assets/images/Perjalanan Bisnis Bersama Bp. Fadly.jpeg',
    title: 'Perjalanan Bisnis Bersama Bp. Fadly',
    description:
      'Pelayanan yang mengutamakan kenyamanan dan kebutuhan setiap pelanggan.',
    alt: 'Pelayanan tim NAYVERA',
    category: 'Pelayanan',
    location: 'NAYVERA INDO TRANSPORT',
  },
  {
    id: 6,
    src: '/assets/images/Armada Hiace Nayvera.jpeg',
    title: 'Armada Siap Berangkat',
    description:
      'Armada siap digunakan untuk berbagai kebutuhan perjalanan pribadi, bisnis, maupun rombongan.',
    alt: 'Armada siap berangkat',
    category: 'Armada',
    location: 'Garasi Hiace Nayvera Indo Transport',
  },
  {
    id: 7,
    src: '/assets/images/Perjalanan Rombongan.jpeg',
    title: 'Momen Perjalanan',
    description:
      'Bukan seberapa jauh kita pergi, tapi dengan siapa kita menikmati perjalanan itu. Setiap momen jadi kenangan yang tak ternilai.',
    alt: 'Perjalanan wisata bersama NAYVERA',
    category: 'Perjalanan',
    location: 'Luar Kota',
  },
  {
    id: 8,
    src: '/assets/images/Driver Taufik - Fadly - Lutfi.jpeg',
    title: 'Tim Profesional',
    description:
      'Tim NAYVERA selalu berusaha memberikan pengalaman pelayanan yang nyaman bagi pelanggan.',
    alt: 'Tim profesional NAYVERA',
    category: 'Driver',
    location: 'NAYVERA INDO TRANSPORT',
  },
  {
    id: 9,
    src: '/assets/images/Driver ArieL.jpeg',
    title: 'Driver ArieL',
    description:
      'Solusi transportasi untuk kebutuhan perusahaan, meeting, kunjungan kerja, dan perjalanan dinas.',
    alt: 'Layanan transportasi perusahaan NAYVERA',
    category: 'Driver',
    location: 'NAYVERA INDO TRANSPORT',
  },
  {
    id: 10,
    src: '/assets/images/Lepas Kunci Bersama Nayvera.jpeg',
    title: 'Lepas Kunci Bersama Nayvera',
    description:
      'Pilihan transportasi untuk kebutuhan Perjalanan Keluarga dengan berbagai pilihan kapasitas kendaraan.',
    alt: 'Perjalanan Keluarga bersama NAYVERA',
    category: 'Pelayanan',
    location: 'Jabodetabek & Luar Kota',
  },
  {
    id: 11,
    src: '/assets/images/Mr. rusia.jpeg',
    title: 'Perjalanan Keluarga Bersama Bp. Rahmat',
    description:
      'Kami percaya perjalanan yang baik dimulai dari komunikasi dan pelayanan yang baik.',
    alt: 'Perjalanan Keluarga bersama NAYVERA',
    category: 'Pelayanan',
    location: 'Dalam Kota Jakarta',
  },
  {
    id: 12,
    src: '/assets/images/keluarga - ruli.png',
    title: 'Momen Perjalanan',
    description:
      'Setiap perjalanan memiliki cerita. NAYVERA hadir untuk membantu membuat perjalanan tersebut lebih nyaman.',
    alt: 'Momen perjalanan bersama NAYVERA',
    category: 'Perjalanan',
    location: 'Indonesia',
  },
];

const categories = [
  'Semua',
  'Armada',
  'Perjalanan',
  'Driver',
  'Pelayanan',
];

const highlights = [
  {
    icon: Car,
    title: 'Armada Terawat',
    description:
      'Armada dipersiapkan untuk memberikan kenyamanan selama perjalanan.',
  },
  {
    icon: UserRound,
    title: 'Driver Profesional',
    description:
      'Driver berpengalaman, ramah, dan siap membantu kebutuhan perjalanan Anda.',
  },
  {
    icon: ShieldCheck,
    title: 'Perjalanan Nyaman',
    description:
      'Kami mengutamakan keamanan, kenyamanan, dan ketepatan waktu.',
  },
  {
    icon: Clock3,
    title: 'Layanan Fleksibel',
    description:
      'Melayani kebutuhan perjalanan pribadi, bisnis, wisata, hingga perusahaan.',
  },
];

export default function GaleriPage() {
  const [activeCategory, setActiveCategory] = useState('Semua');
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const filtered =
    activeCategory === 'Semua'
      ? galleryItems
      : galleryItems.filter(
          (item) => item.category === activeCategory
        );

  const openLightbox = (index: number) => {
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setLightboxIndex(null);
  };

  const prevImage = useCallback(() => {
    if (lightboxIndex === null) return;

    setLightboxIndex(
      (lightboxIndex - 1 + filtered.length) % filtered.length
    );
  }, [lightboxIndex, filtered.length]);

  const nextImage = useCallback(() => {
    if (lightboxIndex === null) return;

    setLightboxIndex(
      (lightboxIndex + 1) % filtered.length
    );
  }, [lightboxIndex, filtered.length]);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (lightboxIndex === null) return;

      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'ArrowRight') nextImage();
    };

    window.addEventListener('keydown', handleKey);

    return () =>
      window.removeEventListener('keydown', handleKey);
  }, [lightboxIndex, prevImage, nextImage]);

  useEffect(() => {
    if (lightboxIndex !== null) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [lightboxIndex]);

  return (
    <>
      <Navbar />

      <main className="min-h-screen bg-white">

        {/* =====================================================
            HERO
        ====================================================== */}
        <section className="relative bg-primary pt-28 pb-20 overflow-hidden">
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-accent blur-3xl" />
            <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full bg-accent blur-3xl" />
          </div>

          <div className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

            <div className="inline-flex items-center gap-2 bg-accent/20 border border-accent/30 rounded-full px-4 py-1.5 mb-5">
              <Camera size={14} className="text-accent" />

              <span className="text-accent text-xs font-bold tracking-widest uppercase">
                Dokumentasi Kami
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-5 tracking-tight">
              Galeri NAYVERA
            </h1>

            <p className="text-white/70 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
              Melihat lebih dekat perjalanan, armada, pelayanan,
              dan momen bersama{' '}
              <span className="text-accent font-semibold">
                NAYVERA INDO TRANSPORT
              </span>
              .
            </p>

          </div>
        </section>


        {/* =====================================================
            FEATURED MOMENT
        ====================================================== */}
        <section className="py-16 sm:py-20 bg-white">
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">

            <div className="text-center mb-10">
              <span className="text-accent text-xs font-bold tracking-[0.2em] uppercase">
                Momen Pilihan
              </span>

              <h2 className="text-3xl sm:text-4xl font-extrabold text-primary mt-2">
                Perjalanan Dimulai dari Kenyamanan
              </h2>

              <p className="text-gray-500 max-w-2xl mx-auto mt-4 leading-relaxed">
                Setiap perjalanan memiliki cerita. Kami hadir untuk
                memberikan pengalaman transportasi yang nyaman,
                aman, dan profesional.
              </p>
            </div>


            <div className="grid lg:grid-cols-2 gap-8 items-stretch">

              {/* Featured Image */}
              <div
                className="relative min-h-[360px] lg:min-h-[480px] rounded-3xl overflow-hidden bg-gray-100 border border-gray-100 shadow-lg group cursor-pointer"
                onClick={() => openLightbox(0)}
              >

                {galleryItems[0].src ? (
                  <img
                    src={galleryItems[0].src}
                    alt={galleryItems[0].alt}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                ) : (
                  <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200">
                    <Camera
                      size={48}
                      className="text-gray-300 mb-3"
                    />

                    <span className="text-gray-400 text-sm font-medium">
                      FOTO UTAMA
                    </span>

                    <span className="text-gray-300 text-xs mt-1">
                      Isi gambar nanti di bagian src
                    </span>
                  </div>
                )}

                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />

                <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8">

                  <span className="inline-flex bg-accent text-primary text-xs font-bold px-3 py-1 rounded-full mb-3">
                    {galleryItems[0].category}
                  </span>

                  <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2">
                    {galleryItems[0].title}
                  </h3>

                  <p className="text-white/75 text-sm sm:text-base max-w-xl leading-relaxed">
                    {galleryItems[0].description}
                  </p>

                </div>

                <div className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/15 backdrop-blur-md border border-white/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <ZoomIn size={20} className="text-white" />
                </div>

              </div>


              {/* Featured Text */}
              <div className="rounded-3xl bg-gray-50 border border-gray-100 p-7 sm:p-10 flex flex-col justify-center">

                <span className="text-accent text-xs font-bold tracking-[0.2em] uppercase mb-4">
                  Tentang Kami
                </span>

                <h3 className="text-2xl sm:text-3xl font-extrabold text-primary leading-tight mb-5">
                  Lebih dari Sekadar Transportasi
                </h3>

                <p className="text-gray-600 leading-relaxed mb-6">
                  NAYVERA INDO TRANSPORT hadir untuk membantu
                  kebutuhan perjalanan Anda dengan pilihan kendaraan
                  dan layanan yang dapat disesuaikan dengan kebutuhan.
                </p>

                <div className="space-y-4 mb-8">

                  {[
                    'Melayani perjalanan pribadi dan keluarga',
                    'Kebutuhan perjalanan bisnis dan perusahaan',
                    'Perjalanan wisata dan rombongan',
                    'Layanan kendaraan dengan driver profesional',
                  ].map((text, index) => (
                    <div
                      key={index}
                      className="flex items-start gap-3"
                    >
                      <CheckCircle2
                        size={20}
                        className="text-green-600 flex-shrink-0 mt-0.5"
                      />

                      <span className="text-gray-700 text-sm leading-relaxed">
                        {text}
                      </span>
                    </div>
                  ))}

                </div>

                <a
                  href="https://wa.me/6287786556067"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-primary text-white px-6 py-3.5 rounded-xl font-semibold hover:opacity-90 transition-opacity w-fit"
                >
                  Konsultasi Perjalanan
                  <ArrowRight size={18} />
                </a>

              </div>

            </div>
          </div>
        </section>


        {/* =====================================================
            CATEGORY FILTER
        ====================================================== */}
        <section className="sticky top-16 z-30 bg-white/95 backdrop-blur-md border-y border-gray-100 shadow-sm">

          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">

            <div className="flex items-center gap-2 overflow-x-auto py-4 scrollbar-hide">

              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => {
                    setActiveCategory(cat);
                    setLightboxIndex(null);
                  }}
                  className={`flex-shrink-0 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 ${
                    activeCategory === cat
                      ? 'bg-primary text-white shadow-md'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  {cat}
                </button>
              ))}

            </div>

          </div>
        </section>


        {/* =====================================================
            GALLERY
        ====================================================== */}
        <section className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">

            <div>
              <span className="text-accent text-xs font-bold tracking-[0.2em] uppercase">
                Dokumentasi
              </span>

              <h2 className="text-3xl font-extrabold text-primary mt-1">
                Momen Bersama NAYVERA
              </h2>

              <p className="text-gray-500 mt-2 text-sm">
                Pilih foto untuk melihat keterangan lebih lengkap.
              </p>
            </div>

            <div className="text-sm text-gray-400">
              {filtered.length} dokumentasi
            </div>

          </div>


          {filtered.length === 0 ? (

            <div className="text-center py-24 text-gray-400">
              <Camera
                size={40}
                className="mx-auto mb-4 text-gray-300"
              />

              <p className="text-lg font-medium">
                Belum ada foto di kategori ini.
              </p>
            </div>

          ) : (

            <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5">

              {filtered.map((item, index) => (

                <div
                  key={item.id}
                  className="break-inside-avoid group relative overflow-hidden rounded-2xl cursor-pointer bg-gray-100 shadow-sm hover:shadow-xl transition-all duration-300"
                  onClick={() => openLightbox(index)}
                >

                  {/* Image / Placeholder */}
                  <div className="relative min-h-[260px]">

                    {item.src ? (

                      <img
                        src={item.src}
                        alt={item.alt}
                        className="w-full object-cover transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                      />

                    ) : (

                      <div className="min-h-[260px] flex flex-col items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200">

                        <Camera
                          size={38}
                          className="text-gray-300 mb-3"
                        />

                        <span className="text-gray-400 text-sm font-semibold">
                          FOTO {String(item.id).padStart(2, '0')}
                        </span>

                        <span className="text-gray-300 text-xs mt-1 text-center px-5">
                          Isi gambar pada bagian <b>src</b>
                        </span>

                      </div>

                    )}


                    {/* Hover Overlay */}
                    <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/70 transition-all duration-300 flex items-center justify-center">

                      <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center gap-2">

                        <div className="bg-white/20 backdrop-blur-sm rounded-full p-3 border border-white/40">
                          <ZoomIn
                            size={22}
                            className="text-white"
                          />
                        </div>

                        <span className="text-white text-xs font-semibold">
                          Lihat Foto
                        </span>

                      </div>

                    </div>


                    {/* Category */}
                    <div className="absolute top-3 left-3">

                      <span className="bg-accent text-primary text-xs font-bold px-3 py-1 rounded-full shadow-sm">
                        {item.category}
                      </span>

                    </div>

                  </div>


                  {/* Card Information */}
                  <div className="bg-white p-5">

                    <h3 className="text-base font-bold text-primary mb-2">
                      {item.title}
                    </h3>

                    <p className="text-gray-500 text-sm leading-relaxed mb-3">
                      {item.description}
                    </p>

                    <div className="flex items-center gap-2 text-gray-400 text-xs">
                      <MapPin size={14} />
                      <span>{item.location}</span>
                    </div>

                  </div>

                </div>

              ))}

            </div>

          )}

        </section>


        {/* =====================================================
            EXPERIENCE / HIGHLIGHTS
        ====================================================== */}
        <section className="bg-gray-50 border-y border-gray-100 py-16">

          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">

            <div className="text-center mb-10">

              <span className="text-accent text-xs font-bold tracking-[0.2em] uppercase">
                Pengalaman Bersama Kami
              </span>

              <h2 className="text-3xl sm:text-4xl font-extrabold text-primary mt-2">
                Kenapa Memilih NAYVERA?
              </h2>

              <p className="text-gray-500 max-w-2xl mx-auto mt-4">
                Kami berusaha memberikan pengalaman perjalanan yang
                nyaman dari awal hingga akhir.
              </p>

            </div>


            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">

              {highlights.map((item, index) => {

                const Icon = item.icon;

                return (
                  <div
                    key={index}
                    className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-lg transition-shadow"
                  >

                    <div className="w-12 h-12 rounded-xl bg-primary/5 flex items-center justify-center mb-5">
                      <Icon
                        size={24}
                        className="text-primary"
                      />
                    </div>

                    <h3 className="text-lg font-bold text-primary mb-2">
                      {item.title}
                    </h3>

                    <p className="text-gray-500 text-sm leading-relaxed">
                      {item.description}
                    </p>

                  </div>
                );

              })}

            </div>

          </div>

        </section>


        {/* =====================================================
            STATISTICS
        ====================================================== */}
        <section className="bg-primary py-14">

          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">

            <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/10">

              <div className="text-center px-4">
                <div className="text-3xl sm:text-4xl font-extrabold text-accent">
                  28+
                </div>
                <div className="text-white/60 text-xs sm:text-sm mt-2">
                  Armada
                </div>
              </div>

              <div className="text-center px-4">
                <div className="text-3xl sm:text-4xl font-extrabold text-accent">
                  24/7
                </div>
                <div className="text-white/60 text-xs sm:text-sm mt-2">
                  Layanan
                </div>
              </div>

              <div className="text-center px-4 mt-8 lg:mt-0">
                <div className="text-3xl sm:text-4xl font-extrabold text-accent">
                  PRO
                </div>
                <div className="text-white/60 text-xs sm:text-sm mt-2">
                  Driver Profesional
                </div>
              </div>

              <div className="text-center px-4 mt-8 lg:mt-0">
                <div className="text-3xl sm:text-4xl font-extrabold text-accent">
                  ALL
                </div>
                <div className="text-white/60 text-xs sm:text-sm mt-2">
                  Jabodetabek & Luar Kota
                </div>
              </div>

            </div>

          </div>

        </section>


        {/* =====================================================
            CTA
        ====================================================== */}
        <section className="py-20 bg-white">

          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">

            <div className="relative overflow-hidden rounded-3xl bg-gray-50 border border-gray-100 px-6 py-12 sm:px-12 text-center">

              <div className="absolute -top-20 -right-20 w-56 h-56 rounded-full bg-accent/10 blur-3xl" />
              <div className="absolute -bottom-20 -left-20 w-56 h-56 rounded-full bg-primary/5 blur-3xl" />

              <div className="relative">

                <span className="text-accent text-xs font-bold tracking-[0.2em] uppercase">
                  Siap Berangkat?
                </span>

                <h2 className="text-3xl sm:text-4xl font-extrabold text-primary mt-3 mb-4">
                  Rencanakan Perjalanan Anda Bersama NAYVERA
                </h2>

                <p className="text-gray-500 max-w-2xl mx-auto leading-relaxed mb-8">
                  Konsultasikan kebutuhan kendaraan Anda dengan tim
                  NAYVERA INDO TRANSPORT. Kami siap membantu
                  menyesuaikan kendaraan dengan kebutuhan perjalanan Anda.
                </p>

                <a
                  href="https://wa.me/6287786556067"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-primary text-white px-7 py-3.5 rounded-xl font-semibold hover:opacity-90 transition-opacity shadow-lg"
                >
                  Hubungi Kami via WhatsApp
                  <ArrowRight size={18} />
                </a>

              </div>

            </div>

          </div>

        </section>

      </main>


      {/* =====================================================
          LIGHTBOX
      ====================================================== */}
      {lightboxIndex !== null && (

        <div
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center"
          onClick={closeLightbox}
        >

          {/* Close */}
          <button
            className="absolute top-4 right-4 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 rounded-full p-2.5 transition-colors z-20"
            onClick={closeLightbox}
            aria-label="Tutup"
          >
            <X size={22} />
          </button>


          {/* Previous */}
          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 rounded-full p-3 transition-colors z-20"
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
            aria-label="Sebelumnya"
          >
            <ChevronLeft size={26} />
          </button>


          {/* Image + Information */}
          <div
            className="relative max-w-5xl w-full max-h-[90vh] mx-16 flex flex-col items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >

            {filtered[lightboxIndex].src ? (

              <img
                src={filtered[lightboxIndex].src}
                alt={filtered[lightboxIndex].alt}
                className="max-w-full max-h-[72vh] object-contain rounded-xl shadow-2xl"
              />

            ) : (

              <div className="w-full max-w-4xl h-[55vh] rounded-xl bg-gradient-to-br from-gray-800 to-gray-900 flex flex-col items-center justify-center border border-white/10">

                <Camera
                  size={60}
                  className="text-white/20 mb-4"
                />

                <span className="text-white/50 text-sm font-semibold">
                  FOTO BELUM DIISI
                </span>

                <span className="text-white/30 text-xs mt-2">
                  Ganti nilai src pada data galeri
                </span>

              </div>

            )}


            {/* Information */}
            <div className="w-full max-w-4xl mt-4 bg-black/60 backdrop-blur-md rounded-xl px-5 py-4">

              <div className="flex flex-wrap items-center gap-2 mb-2">

                <span className="text-accent text-xs font-bold">
                  {filtered[lightboxIndex].category}
                </span>

                <span className="text-white/30">
                  •
                </span>

                <span className="text-white/50 text-xs">
                  {filtered[lightboxIndex].location}
                </span>

              </div>

              <h3 className="text-white text-lg font-bold mb-1">
                {filtered[lightboxIndex].title}
              </h3>

              <p className="text-white/60 text-sm leading-relaxed">
                {filtered[lightboxIndex].description}
              </p>

              <div className="text-white/30 text-xs mt-3">
                {lightboxIndex + 1} / {filtered.length}
              </div>

            </div>

          </div>


          {/* Next */}
          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 rounded-full p-3 transition-colors z-20"
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            aria-label="Berikutnya"
          >
            <ChevronRight size={26} />
          </button>

        </div>

      )}


      <Footer />
      <WhatsAppFloat />

    </>
  );
}